import { ReactElement } from 'react';
import styles from '../SpecialistPersonalCard.module.scss';
import { Breadcrumbs, Typography } from '../../../../1_shared/ui';
import { Slots, SpecialistReserveSlot } from '../../../../3_features';

import { Link } from 'react-router-dom';
import { RoutePath } from '../../../../1_shared/config/routes';

import SpecialisationInfo from '../../../../3_features/SpecialisationInfo/ui/SpecialisationInfo';
import { ISpecInfoProps } from './ISpecInfoProps';

const SpecInfo = ({
  specialist,
  pageType,
  onChange,
}: ISpecInfoProps): ReactElement => {
  const { id, firstName, secondName, slots } = specialist;

  const breadCrumbs = [
    {
      title: (
        <Link to={RoutePath.MAIN}>
          <Typography type="description">DOTHERAPY</Typography>
        </Link>
      ),
    },
    {
      title: (
        <Link to={RoutePath.SPECIALISTS}>
          <Typography type="description">СПЕЦИАЛИСТЫ</Typography>
        </Link>
      ),
    },
  ];

  return (
    <div className={styles.specInfoContainer}>
      <div className={styles.specialistInfoWrapper}>
        <div className={styles.specName}>
          <Breadcrumbs items={breadCrumbs} />
          <Typography className={styles.firstName} type="h1">
            {firstName}
          </Typography>
          <Typography className={styles.secondName} type="h1">
            {secondName}
          </Typography>
        </div>
        <SpecialistReserveSlot
          specialistId={id}
          spec={specialist}
          pageType={pageType}
        />
      </div>
      <SpecialisationInfo specialist={specialist} />
      <Slots
        slots={slots}
        spec={specialist}
        onChange={onChange}
        label="ПОКАЗАТЬ ВСЕ СЛОТЫ"
        pageType={pageType}
      />
    </div>
  );
};

export default SpecInfo;
